// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Container":"Container-ap3j4jf2eyf1816n7q4h4nvcnh7v1rbkanvrzzckj831takqb619nng6eeweev7e9592m4u65wge6ddy7e2735z4crcn2xs9w55hym","IFrame":"IFrame-2yeyahjds5dn4y7qrssbdbw54phps1ayn7r4wgxhctwqherucyaa38de4r2nksu1mqx3quka1ge7pyt9hrdcfcwbp66ahtadaevsnu1","loading":"loading-3gngy1rtjwdk538scyfejv5mnyzgn1cnfhza3tvsvye11hatz5zuwvyqvjpy82cq42t9rnm2rerb5w6krbbsta4mfx4dqgwdqsky4dy","pulse":"pulse-4p3vhk55ngxdxvbxg3tdq2mx244g8ynh976ffmqpfzfae1nr32zafhgfvqmajtkckw9qkp1f6qzs2u8mp57s9e3yxwuggb7dyu3r34g"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/VideoSection/VideoSection.module.scss
// module id = 1700
// module chunks = 0